import { default as dayjs } from "dayjs";
import { default as LocalizedFormat } from "dayjs/plugin/localizedFormat";
import { default as utc } from "dayjs/plugin/utc";
import { default as tz } from "dayjs/plugin/timezone";
import { default as relativeTime } from "dayjs/plugin/relativeTime";

dayjs.extend(LocalizedFormat);
dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(relativeTime);

const timeZone = dayjs.tz.guess();

export function readableDateTime(date: Date) {
  if (!date) {
    return "N/A";
  }
  return dayjs.utc(date).tz(timeZone).format("lll") || "N/A";
}

export function fuzzyTimeAgo(date: string | Date): string {
  if (!date) {
    return "N/A";
  }

  const now = dayjs();
  const targetDate = dayjs(date);
  const diffInDays = now.diff(targetDate, 'day');
  const diffInMonths = now.diff(targetDate, 'month');
  const diffInYears = now.diff(targetDate, 'year');

  if (diffInYears >= 1) {
    return `${diffInYears} year${diffInYears > 1 ? 's' : ''} ago`;
  } else if (diffInMonths >= 1) {
    return `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`;
  } else if (diffInDays >= 1) {
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  } else {
    const diffInHours = now.diff(targetDate, 'hour');
    if (diffInHours >= 1) {
      return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    } else {
      const diffInMinutes = now.diff(targetDate, 'minute');
      return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
    }
  }
}
